import axios from 'axios';
import _ from 'lodash';
import { useContext, useEffect, useState } from 'react';
import { fromApi } from '../../../common/models/asset';
import { AuthContext } from '../../../app/AuthContext';

export function useFetchUserAssets(userData = {}) {
  const { authContext } = useContext(AuthContext);
  const [loaded, setLoaded] = useState(false);
  const [userAssets, setUserAssets] = useState([]);
  const fetchAssets = search => {
    axios
      .get(
        `${process.env.REACT_APP_PUBLIC_API_URL}/assets/user/${userData.uuid}${
          search ? `?search=${search}` : ''
        }`,
        {
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
            authorization: `Bearer ${authContext.token}`,
          },
        },
      )
      .then(response => {
        const userAssets = response.data.map(fromApi);
        setUserAssets(userAssets);
        setLoaded(true);
        return response.data;
      })
      .catch(error => {
        if (process.env.REACT_APP_VERBOSE === 'true') console.log(error);
      });
  };

  useEffect(() => {
    if (userData.id && _.isEmpty(userAssets) && loaded === false) {
      fetchAssets();
    }
  }, [userData, loaded]);

  return { userAssets, loaded, fetchAssets };
}
